import SDK from "Components/SDK";
import { login } from "Components/WebChat/Authentication/Reconnect";
import { deleteItemFromSessionStorage, encryptAndStoreInLocalStorage } from "Components/WebChat/WebChatEncryptDecrypt";
import { getAutomationLoginCredentials, getInitializeObj } from "Helpers/Utility";
import { LoginService } from "./LoginService";
import { getAuthUserDetails } from "./helpers";
import { isCurrentSessionActive, updateSessionId } from "Helpers/Chat/ChatHelper";

export const WebchatLoginService = {
    init: async () => {
        const initializeObj = getInitializeObj();
        const response = await SDK.initializeSDK(initializeObj);
        if (response.statusCode === 200){
            SDK.setMediaEncryption(true); //Enable the media encryption

            if (LoginService.isUserLoggedIn()) {
                WebchatLoginService.login();
            }
        }
        else {
            console.log("Intialize error, ", response);
        }
    },
    login: (options = {}) => {
        if (!isCurrentSessionActive()) return;
        const authUserDetails = getAuthUserDetails();
        SDK.externalAppConnect({
            ...authUserDetails,
            username: authUserDetails.userId,
            forceReconnect: options.forceReconnect === true
        })
            .then((res) => {

                if (res.statusCode === 200) {
                    updateSessionId(Date.now());
                    // login();
                    
                    // let resource = SDK.getCurrentUserJid();
                    // if (resource.statusCode === 200){
                    //     encryptAndStoreInLocalStorage("loggedInUserJidWithResource", resource.userJid);
                    // }
                    deleteItemFromSessionStorage("isLogout");
                    encryptAndStoreInLocalStorage("recordingStatus", true);

                    if(res?.data?.audioLimit || res?.data?.videoLimit){
                        const settings = {
                          audioLimit: res.data.audioLimit,
                          videoLimit: res.data.videoLimit,
                          videoSizeLimit: res.data.videoSizeLimit,
                          fileSizeLimit: res.data.fileSizeLimit
                        }
                        encryptAndStoreInLocalStorage("settings", settings);
                    }
                }
                else if(res.statusCode === 401){
                    // Token expired
                    LoginService.logout();
                }
                else {
                    throw new Error("Something went wrong");
                }
                // else if (res.statusCode === 403) {
                //     Store.dispatch(adminBlockStatusUpdate({
                //       toUserId: response.username,
                //       isAdminBlocked: true
                //     }));
                //     // logout('', res?.message);
                //     // return
                // }
            })
            .catch((error) => {
                console.log('responseresponse -- UIKIT handleLogin -- ', error);
                console.log("handleLogin error, ", error);
                // deleteItemFromLocalStorage('username');
                // deleteItemFromLocalStorage("auth_user");
                // window.location.reload();
            });

    }
}